import Action from './action';

const initialState = {
    phoneRepair: sessionStorage.getItem('phoneRepair') || '',
};

export default (state = initialState, action: {type: string, playload: string}) => {
    switch (action.type) {
        case Action.UPDATE_VERIFY_REPAIR_PHONE_TEXT: {
            sessionStorage.setItem('phoneRepair', action.playload);
            return {
                ...state,
                phoneRepair: action.playload
            }
        }
        default: return state;
    }
}
